import React, { useEffect, useState, useRef } from 'react';
interface LazySectionProps {
  children: ReactNode;
  /** Minimum height placeholder to prevent CLS */
  minHeight?: string;
}
/**
 * Defers rendering of below-fold sections until they're near the viewport.
 * Reduces initial DOM size and JS execution for better FCP/TBT.
 */
export function LazySection({
  children,
  minHeight = '200px'
}: LazySectionProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Use a generous margin so content loads before user scrolls to it
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShouldRender(true);
        observer.disconnect();
      }
    }, {
      rootMargin: '400px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} style={{
    minHeight: shouldRender ? undefined : minHeight
  }} data-id="element-554">
      {shouldRender ? children : null}
    </div>;
}